import { BottomNavigation, Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'hooks/useTranslation';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{ height: '40px', width: '100%', position: 'fixed', bottom: 0, left: 0, zIndex: 1200 }}
    >
      <BottomNavigation sx={{ backgroundColor: '#5A5D60', height: '40px', zIndex: 1200 }}>
        <Typography sx={{ color: 'white', mt: '8px', align: 'center' }}>
          {t('footer.footer_text')}
        </Typography>
      </BottomNavigation>
    </Box>
  );
};

export default Footer;
